import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Index from './views/Index.vue'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/panel',
            name: 'Index',
            component: Index
        },
        {
            path: '/banner/',
            name: 'CreateBanner',
            component: () => import(/* webpackChunkName: "banner" */ './views/EditBanner.vue')
        },
        {
            path: '/banner/:id',
            name: 'EditBanner',
            component: () => import(/* webpackChunkName: "banner" */ './views/EditBanner.vue')
        },
        {
            path: '/notification/',
            name: 'CreateNotification',
            component: () => import(/* webpackChunkName: "notification" */ './views/EditNotification.vue')
        },
        {
            path: '/notification/:id',
            name: 'EditNotification',
            component: () => import(/* webpackChunkName: "notification" */ './views/EditNotification.vue')
        }
    ]
})
